import type { AppData, RouteResult, Shop } from "../types";

export type IssueType =
  | "Wrong shop info"
  | "Wrong lot/location"
  | "Navigation instruction unclear"
  | "Missing shop"
  | "App error"
  | "Other";

export interface IssueContext {
  type: IssueType;
  note: string;
  routePath: string;
  shop: Shop | null;
  routeResult: RouteResult | null;
  appData: AppData;
  floorId: string | null;
  screenSize: string;
}

export function formatIssueReport(context: IssueContext): string {
  const lines = [
    `Issue type: ${context.type}`,
    `Page: ${context.routePath}`,
    `Data version: ${context.appData.manifest.dataVersion}`,
    `Start point: IOI Tower Two entrance`,
    `Screen: ${context.screenSize}`
  ];

  if (context.shop) {
    lines.push(`Shop: ${context.shop.name} (${context.shop.id})`);
    lines.push(`Location: ${context.shop.locationCode}`);
    lines.push(`Navigation quality: ${context.shop.navigationDataQuality}`);
  }

  if (context.floorId) {
    lines.push(`Map floor: ${context.floorId}`);
  }

  if (context.routeResult) {
    lines.push(`Route status: ${context.routeResult.status}`);
  }

  lines.push("", "User note:", context.note.trim() || "(No note provided)");

  return lines.join("\n");
}

